import Brick from 'stores/brick';
import Tree from 'stores/tree';
import Construction from 'stores/construction';

export default class AppStore {
    brick = new Brick(this);
    brickTree = new Tree(this, true, 'brick');
    constructionTree = new Tree(this, true, 'construction');
    streetTree = new Tree(this, false);
    construction = new Construction(this);
}